// Router Module
import { state, updateState } from './state.js';
import { loadSettings } from '../modules/settings.js';
import { loadPasswordPolicy } from '../modules/password-policy.js';
import { loadRoles } from '../modules/roles.js';
import { loadLicenses } from '../modules/licenses.js';
import { loadPackages } from '../modules/packages.js';
import { loadClients } from '../modules/clients.js';
import { loadBilling } from '../modules/billing.js';
import { loadStats } from '../modules/dashboard.js';
import { loadAgents } from '../modules/agents.js';
import { loadThreats } from '../modules/threats.js';
import { loadUsers } from '../modules/users.js';
import { loadProfile } from '../modules/profile.js';

export function switchView(viewName) {
    try {
        console.log(`[Router] Switching to view: ${viewName}`);

        // If we're on a server-rendered detail page, don't hide it
        const detailPages = ['view-client-detail', 'view-server-detail'];
        for (const pageId of detailPages) {
            if (document.getElementById(pageId)) {
                console.log(`[Router] On server-rendered ${pageId} page, skipping view switching`);
                return;
            }
        }

        // Hide all views
        document.querySelectorAll('[id^="view-"]').forEach(section => {
            section.classList.remove('active');
            section.classList.add('hidden');
        });

        // Show target view
        const targetView = document.getElementById(`view-${viewName}`);
        if (targetView) {
            targetView.classList.add('active');
            targetView.classList.remove('hidden');
        } else {
            console.warn(`[Router] View not found: view-${viewName}`);
        }

        // Update active nav link
        document.querySelectorAll('.nav-link').forEach(link => {
            link.classList.remove('active');
        });

        const activeLink = document.querySelector(`[data-view="${viewName}"]`);
        if (activeLink) {
            activeLink.classList.add('active');
        }

        // Load data for specific views
        console.log(`[Router] Loading data for view: ${viewName}`);
        switch (viewName) {
            case 'dashboard':
                loadStats();
                break;
            case 'settings':
                loadSettings();
                break;
            case 'password-policy':
                loadPasswordPolicy();
                break;
            case 'roles':
                loadRoles();
                break;
            case 'licenses':
                loadLicenses();
                break;
            case 'pricing':
                loadPackages();
                break;
            case 'clients':
                loadClients();
                break;
            case 'billing':
                loadBilling();
                break;
            case 'agents':
                loadAgents();
                break;
            case 'threats':
                loadThreats();
                break;
            case 'users':
                loadUsers();
                break;
            case 'profile':
                loadProfile();
                break;
            default:
                console.log(`[Router] No data loader for view: ${viewName}`);
        }

        updateState({ currentView: viewName });
    } catch (error) {
        console.error('[Router] Error switching view:', error);
    }
}

// Make globally available
window.switchView = switchView;
